import React from 'react';

import { useAppContext } from '../../contexts/AppContext';
import useServerSideRendering from '../../hooks/useServerSideRendering';
import { getImgxSrc } from '../../utils/images';
import Button from '../BaseUI/Button';
import { EventProp } from './TimeLine';

const HorizentalTimePoint = ({ events }: { events: EventProp[] }) => {
  const { env } = useAppContext();
  const hydrated = useServerSideRendering();
  const firstEvent = events[0];
  const secondEvent = events[1];

  return (
    <div className="tw-w-full tw-border-0 tw-border-b-2 tw-border-solid tw-h-[200px] tw-relative tw-border-gray-200">
      <div>
        {hydrated && (
          <img
            className="tw-max-w-[200px] tw-absolute tw-left-[10rem]"
            src={getImgxSrc({
              path: firstEvent.logoPath,
              isDevDependence: true,
              envContext: env,
            })}
            alt="TI Time Line"
          />
        )}
        <div className="tw-w-full tw-max-w-[260px] tw-absolute tw-top-[4rem] tw-left-[16rem]">
          <Button
            variant="link"
            className="tw-font-serif tw-text-button-lg sm:tw-text-[22px] sm:tw-leading-8 tw-underline tw-leading-6 tw-text-left tw-tracking-normal"
            href={firstEvent.articleLink}
          >
            “{firstEvent.articleTitle}”
          </Button>
        </div>
        {hydrated && (
          <img
            className="tw-absolute tw-top-72 tw-left-[14rem]"
            src={getImgxSrc({
              path: 'brand_campaign/pinRed.svg',
              isDevDependence: true,
              envContext: env,
            })}
            alt="TI Time Line"
          />
        )}
        <div className="tw-absolute -tw-bottom-48 tw-left-[12rem] tw-text-pro-red tw-font-sans tw-text-body-sm tw-font-bold tw-uppercase">
          {firstEvent.month} {firstEvent.year}
        </div>
      </div>
      <div>
        {hydrated && (
          <img
            className="tw-max-w-[150px] tw-absolute tw-right-[8rem]"
            src={getImgxSrc({
              path: secondEvent.logoPath,
              isDevDependence: true,
              envContext: env,
            })}
            alt="TI Time Line"
          />
        )}
        <div className="tw-w-full tw-max-w-[260px] tw-text-[16px] tw-font-serif tw-leading-6 sm:tw-leading-6 tw-absolute tw-top-[4rem] -tw-right-[3rem]">
          “{secondEvent.articleTitle}”
        </div>
        {hydrated && (
          <img
            className="tw-absolute tw-top-72 tw-right-[14rem]"
            src={getImgxSrc({
              path: 'brand_campaign/pinGray.svg',
              isDevDependence: true,
              envContext: env,
            })}
            alt="TI Time Line"
          />
        )}
      </div>
      <div className="tw-absolute -tw-bottom-48 tw-right-[12rem] tw-font-sans tw-text-body-sm tw-font-bold tw-uppercase">
        {secondEvent.month} {secondEvent.year}
      </div>
    </div>
  );
};

export default HorizentalTimePoint;
